
export default {
  /**
   * Creates a rules object to pass to the validation provider.
   * 
   * @param {Array} rules
   * 
   * @returns {Object}
   */
  createRulesObject(rules) {
    let ruleObject = {}

    rules.forEach(rule => {
      ruleObject[rule.name] = rule.parameters ?? true
    })

    return ruleObject
  },

  /**
   * Creates a messages object to pass to the validation provider.
   * 
   * @param {Array} rules
   * 
   * @returns {Object}
   */
  createMessagesObject(rules) {
    let messageObject = {}

    rules.forEach(rule => {
      messageObject[rule.name] = rule.message
    })
        
    return messageObject
  },

  //store the validation message
  validationMessage: {},

  /**
   * Save the validation response from leads pipeline
   * 
   * @param {Array} rules
   * 
   * @returns {Object}
   */  
  setValidationMessage(key, message) {
    let messageSplit = message.split(":") //break the object response into two parts
    let messageClean = messageSplit[1].replace(/[^a-zA-Z0-9 ]/g, '').trim() //strip of non-alpha-num chars
    this.validationMessage[key] = messageClean
  },

  /**
   * Retrieve the validation response from leads pipeline
   * 
   * @param {Array} rules
   * 
   * @returns {Object}
   */  
  getValidationMessage(key) {
    return this.validationMessage[key] ?? 'The field is invalid'
  },

}